import React from "react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Seo title="Privacy Policy" description="Privacy Policy for Cody Wallace Enterprises (Iridescent Medical & Wellness Spa), including how phone numbers and SMS consent data are handled." path="/privacy" />
      <PageHeader title="Privacy Policy" subtitle="Cody Wallace Enterprises · Iridescent Medical & Wellness Spa" />
      <div className="max-w-3xl mx-auto px-6 pb-24 text-[#5C6664] leading-relaxed space-y-6">
        <p className="text-sm">Last updated: {new Date().getFullYear()}</p>

        <section>
          <h2 className="font-heading text-2xl text-ink">Information We Collect</h2>
          <p>We collect the information you provide through our forms — such as your name, email, phone number, treatment interests, and message — so we can respond to your inquiry and, with your consent, send appointment and promotional text messages.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-ink">SMS &amp; Mobile Data</h2>
          <p>If you opt in to text messages, we use your mobile number solely to send you the messages you consented to. You will receive <strong>up to 4 messages per month</strong>, and <strong>message and data rates may apply</strong> depending on your carrier plan. <strong>Text-messaging consent and your mobile information are never sold or shared with third parties or affiliates for their marketing purposes.</strong> You can opt out at any time by replying STOP, or reply HELP for assistance.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-ink">How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To respond to inquiries and schedule appointments.</li>
            <li>To send appointment reminders and, with consent, promotions.</li>
            <li>To improve our services and communications.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-ink">Your Choices</h2>
          <p>You may request access to, correction of, or deletion of your information at any time. To make a request or ask a question, call (586) 690-8693.</p>
        </section>
      </div>
    </div>
  );
}
